import React, { useEffect, useState } from "react";
import Select from "react-select";
import { parseCamelKey } from "../../utils/formatersAndParsers";

export default function MySelect({ className, value, onChange, ...props }) {
  const [fieldValue, setFieldValue] = useState("");

  useEffect(() => {
    if (!value) return;

    if (typeof value === "string") {
      setFieldValue({ value: value, label: parseCamelKey(value) });
    } else if (typeof value === "number") {
      setFieldValue({ value: value, label: value });
    } else {
      setFieldValue(value);
    }
  }, [value]);

  return (
    <Select
      className={`w-100 ${className || ""}`}
      classNamePrefix="mySelect"
      components={{
        IndicatorSeparator: () => null,
      }}
      value={fieldValue || ""}
      onChange={selected => {
        onChange(selected?.value || "");
      }}
      {...props}
    />
  );
}
